export default "__VITE_ASSET__DPQQguc6__"